import { render, staticRenderFns } from "./c-like-pro.vue?vue&type=template&id=474c12e8&scoped=true&"
import script from "./c-like-pro.vue?vue&type=script&lang=js&"
export * from "./c-like-pro.vue?vue&type=script&lang=js&"
import style0 from "./c-like-pro.vue?vue&type=style&index=0&id=474c12e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474c12e8",
  null
  
)

export default component.exports